export const DEFAULT = "none-selected";

// The locations did
export type Location = string | undefined;
